import { type ResolvedContextData } from '@common/defaults/ContextData';
import { CommentIcon } from '@common/svg/icons/components/CommentIcon';
import { Route } from '@common/types/Route';
import { WidgetType } from '@common/types/Sidebar';
import { ShowMoreLink } from '@web/atoms/ShowMoreLink';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import type { SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

export interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'transfers.title',
    type: WidgetType.TRANSFER_RUMOUR,
};

export const Widget = ({ contextData, dataList }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    const metaSuffix = __sidebar('most-comments.count');
    const showMore = __sidebar('rumour.show-more');

    return (
        <SimpleWidget
            contextData={contextData}
            title={title}
            header={<ShowMoreLink route={Route.TransferRumors}>{showMore}</ShowMoreLink>}
        >
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem
                        key={i}
                        contextData={contextData}
                        metaIcon={<CommentIcon />}
                        metaSuffix={metaSuffix}
                        {...data}
                    />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
